import { DropdownItem } from "@amzn/storm-ui";
import ReactMarkdown from "react-markdown";

import { DropdownItemPosition } from "../../types/inputs";

import { DropdownLabel } from "./DropdownLabel";

export interface DropdownItemData {
    value: string;
    label: string;
    [key: string]: string; // used to store auxilary data related to the item
}

export const renderDropdownItems = (
    items: DropdownItemData[],
    loading: boolean,
    onEndScroll?: () => void,
    missingText?: string,
): { renderItems: JSX.Element[] } => {
    const renderItems: JSX.Element[] =
        items.length === 0 && !loading
            ? [
                  <DropdownItem key="no-items" value="n/a" disabled>
                      <ReactMarkdown linkTarget="_blank">
                          {missingText ?? "no items available"}
                      </ReactMarkdown>
                  </DropdownItem>,
              ]
            : items.map(({ label, value }, index) => (
                  <DropdownItem
                      key={`item-${index}`}
                      value={value}
                      data-testid={`dropdown_${value}`}
                  >
                      <DropdownLabel
                          onEndScroll={onEndScroll}
                          label={label ?? value}
                          position={
                              (index === items.length - 1 &&
                                  DropdownItemPosition.LAST) ||
                              DropdownItemPosition.MIDDLE
                          }
                      />
                  </DropdownItem>
              ));
    return { renderItems };
};

export const filterItemByValueAndLabel = (
    items: DropdownItemData[],
    filter: string,
): DropdownItemData[] => {
    return filter.length > 0
        ? items.filter(
              ({ label, value }) =>
                  label?.toLowerCase().includes(filter.toLowerCase()) ||
                  value?.toLowerCase().includes(filter.toLowerCase()),
          )
        : items;
};
